export default __webpack_public_path__ + "static/media/attachmentcenter.93b05bc8.jpg";